module.exports = __webpack_public_path__ + "static/media/builtinv2-cisco 2.dd95485b.png";